import React, { useEffect, useState } from "react";

import Modal from "react-bootstrap/Modal";
import { IoInformationCircle } from "react-icons/io5";

import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import { api } from "../../services/api";

import Rodape from "../../components/Footer/rodape";
import { Menu } from "../../components/Menu";
import { Header } from "../../components/Header";
import { DashLayoutOpenListCourse } from "../../components/DashLayoutOpenListCourse";

import { useNavigate } from "react-router-dom";


import CircularProgress from "@mui/material/CircularProgress";

export const CourseOpenList = () => {
  const _data = JSON.parse(sessionStorage.getItem("@Auth:data"));

  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [chefe, setChefe] = useState("");

  const [courseDetalhDisponiveis, setCourseDetalhDisponiveis] = useState([]);

  const [courseDisponiveis, setCourseDisponiveis] = useState([]);

  const [courseInscricaoDisponiveis, setCourseInscricaoDisponiveis] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const UserChefeOKPre = () =>
    toast.success(
      `Pré-inscrição no ${courseDetalhDisponiveis.nome} realizada com sucesso. Aguarde a confirmação do seu chefe imediato para concluir sua inscrição.`,
      {
        position: "top-center",
        autoClose: 5500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      }
    );

  const UserChefeOkEad = () =>
    toast.success(
      `Inscrição no curso ${courseDetalhDisponiveis.nome} realizada com sucesso  .!`,
      {
        position: "top-center",
        autoClose: 5500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      }
    );

  const UserChefeNot = () =>
    toast.info("Campo obrigatório, Informe o seu chefe imediato", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const UserChefeIsIncorrect = () =>
    toast.warning("Insira o email do seu chefe imediato", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

    const NotId = () =>
      toast.info(
        `carregando...`,
        {
          position: "top-right",
          autoClose: 5500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );

  const NotMessage = (error) =>
    toast.info(
      `:( Ops!, ${error}`,
      {
        position: "top-right",
        autoClose: 5500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );

  const courseDisp = async () => {
    try {
      const httpOptions = {
        headers: {
          Accept: "application/json",
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
        },
      };

      const res = await api.get("/curso/disponiveis", httpOptions);
      setCourseDisponiveis(res.data);
    } catch (error) {
      error;
    }
  };

  useEffect(() => {
    courseDisp();
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, [setCourseDisponiveis]);


  const courseDetail = async (id) => {
    try {  
      const httpOptions = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
        },
      };
  
      const res = await api.get(`/curso/detalhes/${id}`, httpOptions);
      setCourseDetalhDisponiveis(res.data);
    } catch (error) {
      error;
    }
  };

  useEffect(() => {
    courseDetail();
  }, [setCourseDetalhDisponiveis]);

  const courseInscricaoCoursePre = async () => {
    try {
      const _params = {
        "pec": courseDetalhDisponiveis.id,
        "chefe": chefe,
      };
  
      if (!courseDetalhDisponiveis.id) {
        return; // Saia da função se o id for nulo
      }
  
      const httpOptions = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
        },
      };
  
      const res = await api.post("/curso/inscricao", _params, httpOptions);
      setCourseInscricaoDisponiveis(res.data);
      UserChefeOKPre();
    } catch (error) {
      NotMessage(error.response.data.message);
    }
  };
  
  useEffect(() => {
    courseInscricaoCoursePre();
  }, [setCourseInscricaoDisponiveis]);
  
  const courseInscricaoCourse = async () => {
    try {
      const _params = {
        "pec": courseDetalhDisponiveis.id,
        "chefe": chefe,
      };
  
      if (!courseDetalhDisponiveis.id) {
        return; // Saia da função se o id for nulo
      }
  
      const httpOptions = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
        },
      };
  
      const res = await api.post("/curso/inscricao", _params, httpOptions);
      setCourseInscricaoDisponiveis(res.data);
    } catch (error) {
      NotMessage(error.response.data.message);
    }
  };
  
  useEffect(() => {
    courseInscricaoCourse();
  }, [setCourseInscricaoDisponiveis]);
  

  const handleSubmitInscricaoCourse = async (e) => {
    e.preventDefault();

    // Regra antiga (descomente para voltar):
    // if (courseDetalhDisponiveis.modalidade == 2 && !chefe) {
    //   UserChefeNot();
    //   return;
    // }
    //
    // if (courseDetalhDisponiveis.modalidade == 1) {
    if (courseDetalhDisponiveis.modalidade == 1 || courseDetalhDisponiveis.modalidade == 2) {

      UserChefeOkEad();
      setTimeout(() => {
        courseInscricaoCourse();  
        navigate("/esat/sigecap/painel");
      }, 6500);
      return;
    } else {
      if (courseDetalhDisponiveis.modalidade == 2)  {
        courseInscricaoCoursePre();    
      } else {
        UserChefeIsIncorrect();
        return;
      }
    }
  };

  return (
    <>
      <Header />
      <Menu />
      <DashLayoutOpenListCourse>
        <h3 style={{ color: "#ccc" }}>CURSOS DISPONÍVEIS</h3>
        <hr style={{ color: "#ccc" }} />
        <br />
        {isLoading !== false ? (
          <>
            {" "}
            <center>
              <h4 style={{ color: "#568989" }}>Carregando.... </h4>
              <br />
              <CircularProgress />
            </center>
          </>
        ) : (
          <>
            {courseDisponiveis.length > 0 ? (
              <>
                <Row xs={1} md={2} className="g-4">
                  {courseDisponiveis.map((item, i) => (
                    <>
                      <Col
                        style={{ display: "flex" }}
                        className="card-response"
                        key={i}
                      >
                        <Card style={{ width: "18rem" }}>
                          <Card.Img
                            variant="top"
                            src="data:image/png;base64,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"
                          />
                          <Card.Body>
                            <Card.Title style={{ fontSize: 13 }}>
                              {item.nome}
                              <hr
                                style={{ color: "rgb(231 13 13)", fontSize: 8 }}
                              />
                            </Card.Title>
                            <Card.Text style={{ color: "red", fontSize: 20 }}>
                              {item.ch}h
                            </Card.Text>
                            <Link onClick={handleShow}>
                              <Button
                                variant="danger"
                                onClick={() => courseDetail(item.id)}
                              >
                                Detalhes
                              </Button>
                            </Link>
                          </Card.Body>
                        </Card>
                      </Col>
                    </>
                  ))}
                </Row>
              </>
            ) : (
              <>
                {" "}
                <center>
                  <h4 style={{ color: "#898282" }}>
                    {" "}
                    Não existe curso disponível no momento....
                  </h4>
                  <br />
                </center>
              </>
            )}
          </>
        )}

        <div
          className="modal show"
          style={{ display: "block", position: "initial" }}
        >
          <Modal centered show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>{courseDetalhDisponiveis.nome}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <b className="text-black">OBJETIVO </b>
              <br />
              <br />
              <p>{courseDetalhDisponiveis.objetivo}</p>
              <hr />
              <b className="text-black mt-[10px]">
                {courseDetalhDisponiveis.ch} Horas
              </b>
              <br />

              {courseDetalhDisponiveis.inscricao !== false ? (
                <>
                  {/* Regra antiga: modalidade === "2" */}
                  {courseDetalhDisponiveis.modalidade === "3" ? (
                    <>
                      <input
                        class="form-control"
                        type="number"
                        value={courseDetalhDisponiveis.id}
                        hidden
                      />
                      <hr />
                      <br />
                      <h6 className="mt-[-22px]">Chefe Imediato</h6>
                       <input
                        class="form-control"
                        type="text"
                        value={chefe}
                        onChange={(e) => setChefe(e.target.value)}
                        placeholder="Informe o e-mail do seu Chefe Imediato"
                      />
                      <button
                        onClick={handleSubmitInscricaoCourse}
                        className="btn btn-block btn-danger strong w-full mt-[20px]"
                      >
                        {" "}
                        <b className="text-white">Inscrever-me</b>
                      </button>
                      <hr />
                    </>
                  ) : (
                    <>
                      {" "}
                      <button
                        onClick={handleSubmitInscricaoCourse}
                        className="btn btn-block btn-danger strong w-full mt-[20px]"
                      >
                        {" "}
                        <b className="text-white">Inscrever-me</b>
                      </button>
                    </>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <button className="btn btn-block border strong w-full mt-[20px]">
                    {" "}
                    <b className="text-white; background: #red">
                      Número de vagas preenchidas
                    </b>
                  </button>
                </>
              )}
            </Modal.Body>

            <Modal.Body>
              <b className="text-black mt-[-25px]">
                {courseDetalhDisponiveis.modalidade === "1"
                  ? "Tutor: "
                  : "Facilitador: "}
              </b>
              {courseDetalhDisponiveis?.facilitador?.nome}
              <hr />
              <b className="text-black mt-[10px]">Modalidade: </b>{" "}
              {courseDetalhDisponiveis.modalidade === "1"
                ? "EaD"
                : "Presencial"}
              <hr />
              <b className="text-black mt-[10px]">Tipo: </b>{" "}
              {courseDetalhDisponiveis.tipo === "1"
                ? "Técnico"
                : "Comportamental"}
              <hr />
              <b className="text-black mt-[10px]">Período: </b>{" "}
              {courseDetalhDisponiveis?.data?.map(({ data }) => (
                <tr key={data}>
                  <td style={{ border: "none" }}>
                    {" "}
                    {new Date(data)
                      .toLocaleString("pt-BR", { timeZone: "UTC" })
                      .substr(0, 10)}
                  </td>
                </tr>
              ))}
              <hr />
              <b className="text-black mt-[10px]">Carga Horária: </b>{" "}
              {courseDetalhDisponiveis.ch}h
              <hr />
              <b className="text-black mt-[10px]">Público: </b>{" "}
              {courseDetalhDisponiveis.publico}
              <hr />
              <b className="text-black mt-[10px]">Nrº de Vagas: </b>{" "}
              {courseDetalhDisponiveis.vagas}
              <br />
              <ToastContainer />
            </Modal.Body>
            <Modal.Footer>
              <p className="alert alert-info w-full">
                <strong>
                  <IoInformationCircle size={20} />
                  Verifique as informações do curso e efetue a inscrição
                </strong>
              </p>
              {/* <Button variant="danger" onClick={handleClose}>
            <p style={{ color: "black" }}>Close</p>
          </Button> */}
            </Modal.Footer>
          </Modal>
        </div>

        <br />
      </DashLayoutOpenListCourse>
      <Rodape />
    </>
  );
};
